import React from 'react'
import { StaticImage } from "gatsby-plugin-image"

export default function About() {
    return (
        <div id="about" className="bg-black-400 pb-40 relative pt-10"> 
            <div className="w-11/12 max-w-5xl m-auto">
                <h1 className="text-4xl text-center lg:text-5xl text-green-300 font-mono lg:text-right mb-10 font-black">Who am I?</h1>
                <div className="mt-20 flex flex-col items-center lg:flex-row lg:justify-between lg:items-center">
                    <div className="relative">

                        <StaticImage src="../images/profile.jpeg" alt="profile photo" className="w-60 h-60 rounded-full ring-2 ring-offset-4 flex-shrink-0 ring-green-300 ring-offset-black-400 md:mr-4"></StaticImage>
                        <div className="absolute bg-green-300 opacity-30 h-60 w-60 rounded-full top-0 cursor-pointer hover:opacity-0 transform transition-all duration-500"></div>
                    </div>
                    <div className="mt-20 lg:mt-0 z-10">
                        <p className="font-serif text-black-100 text-center lg:text-left text-xl max-w-prose">I am Jintu Kalita, a 3rd year <span className="font-mono text-green-100">Computer Science Undergraduate</span> at National Institute of Technology, Silchar. Most of the times I do Competitive Programming. I enjoy solving programming problems that involves complicated <span className="font-mono text-green-100">Data Structures</span>, <span className="font-mono text-green-100"> Algorithms</span> and some mind bending ideas.</p>
                        <p className="font-serif text-black-100 text-center lg:text-left text-xl max-w-prose mt-4">I also make <span className="font-mono text-green-100">things for the web</span>. I work on both the frontends and the backends on the web, although I might prefer the frontend.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}
